import React from "react";

import { Box, Grid, Typography } from "@mui/material";
import { Expandable } from "uikit/Expandable";
import * as styles from "./faqSection.css";
import * as homeStyles from "styles/Home.css";

const questions = [
  {
    question: "How is my data handled when I use Stat Analyzer?",
    answer:
      "When you upload your bank statements to Stat Analyzer, your data is securely transmitted to our servers for processing. We employ industry-standard encryption protocols to protect your data during transit and while stored. Our servers are hosted in secure data centers that comply with international security standards. We process your data solely to provide you with detailed financial analytics and insights. We do not share your personal data with third parties without your explicit consent.",
  },
  {
    question: "What file formats can I upload for analysis?",
    answer:
      "StatAnalyzer supports CSV and similar text-based formats commonly used for exporting bank statements and financial transactions.",
  },
  {
    question: "How does StatAnalyzer help me understand my spending habits?",
    answer:
      "The app provides interactive dashboards and visual analytics, such as spending trends, category breakdowns, and income vs. expenditure charts, to offer deep insights into your financial habits.",
  },
];

const FAQSection = () => {
  return (
    <Grid>
      <Typography
        className={homeStyles.heading}
        variant="h2"
        fontWeight="bold"
        align="center"
      >
        FAQ
      </Typography>
      <Grid
        direction="column"
        container
        wrap="wrap"
        alignItems="center"
        className={styles.questionsContainerStyle}
      >
        {questions.map(({ question, answer }) => (
          <Box key={question} marginBottom={2} sx={{ zIndex: 15 }}>
            <Expandable title={question} text={answer} />
          </Box>
        ))}
      </Grid>
    </Grid>
  );
};

export default FAQSection;
